import { initialState } from "./state"

export default {
  updateIsSameAddress: (state, payload) => (state.isSameAddress = payload),
  updateCep: (state, payload) => (state.cep = payload),
  updateAddress: (state, payload) => (state.address = payload),
  updateNumber: (state, payload) => (state.number = payload),
  updateNoNumber: (state, payload) => (state.noNumber = payload),
  updateNeighborhood: (state, payload) => (state.neighborhood = payload),
  updateState: (state, payload) => (state.state = payload),
  updateCity: (state, payload) => (state.city = payload),
  updateCityId: (state, payload) => (state.cityId = payload),
  updateStateId: (state, payload) => (state.stateId = payload),
  updateSecondaryAddress: (state, payload) => {
    Object.keys(state.secondaryAddress).forEach(key => {
      if (payload[key] !== undefined) {
        state.secondaryAddress[key] = payload[key]
      }
    })
  },
  resetInstallation: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
